module.exports = __webpack_public_path__ + "static/media/Logo-Sena-Aliados.9dc01edd.png";